import { TokenInfoJson } from '@/types'
import { getCookie } from '@petz/web-utils'

export const getAccessToken = () => {
  const tokenString = getCookie('TOKEN_INFO')
  if (tokenString == null) return null

  const token: TokenInfoJson = JSON.parse(decodeURIComponent(tokenString))
  return token.access_token
}
